/** @jsx jsx */

import React, {
  Fragment as _,
  useState,
  useContext,
  useRef,
  useEffect,
  useLayoutEffect,
  createContext,
  ReactElement,
} from 'react';
import { css, jsx } from '@emotion/core';
import { interactionContext as _interactionContext } from './interactionContext';

interface ResultsPageContentProps {
  children: ReactElement[] | ReactElement | string | null;
}

interface ResultsPageContext {
  passed: boolean;
}

const ResultsPageContext = createContext<ResultsPageContext>(undefined);

const Graph = src => {
  const [graph, setGraph] = useState(null);

  useEffect(() => {
    fetch(src)
      .then(r => {
        console.log(r);
        return r.text();
      })
      .then(r => setGraph(r));
  }, []);

  return graph ? <div dangerouslySetInnerHTML={{ __html: graph }} /> : null;
};

const ResultsPageContent = (props: ResultsPageContentProps) => {
  const interactionContext = useContext(_interactionContext);

  const {
    id: interactionContextId,
    displayPassFailContent,
    score,
    passed,
  } = interactionContext;

  const { showImage = true } = interactionContext.props;

  const { children } = props;

  const getScore = useRef(null);

  useLayoutEffect(() => {
    if (window.dev()) {
      return;
    }

    const allText = Array.from(getScore.current.querySelectorAll('*'));

    allText.forEach((t: any, i) => {
      if (t.innerText && t.innerText.includes('%%SCORE%%')) {
        t.innerHTML = t.innerHTML.replace('%%SCORE%%', `${score}%`);
      }
    });
  });

  return (
    <div
      ref={getScore}
      css={css`
        ${!showImage &&
          `
      // position: absolute;
      // left: 0;
      // top: 0;
      // width: 100%;
    `}
      `}
    >
      {window.dev()
        ? children[displayPassFailContent === 'passed' ? 0 : 1]
        : children[passed ? 0 : 1]}
    </div>
  );
};

export default ResultsPageContent;
export { ResultsPageContext };
